// 팀 API helper — fetch 기반, credentials include 로 세션 쿠키 자동 전송
const BASE = '/api/teams';

async function jsonFetch(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  let data = null;
  try { data = await res.json(); } catch { /* empty body */ }
  if (!res.ok || (data && data.success === false)) {
    const msg = (data && data.error) || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return data;
}

// 팀 자체
export const listMyTeams = () =>
  jsonFetch('/mine');

export const createTeam = (name, description, price_unit) =>
  jsonFetch('/', { method: 'POST', body: JSON.stringify({ name, description, price_unit }) });

export const getTeam = (team_id) =>
  jsonFetch(`/${team_id}`);

export const updateTeam = (team_id, name, description, price_unit) =>
  jsonFetch(`/${team_id}`, { method: 'PUT', body: JSON.stringify({ name, description, price_unit }) });

export const deleteTeam = (team_id) =>
  jsonFetch(`/${team_id}`, { method: 'DELETE' });

// 멤버
export const joinByCode = (join_code) =>
  jsonFetch('/join', { method: 'POST', body: JSON.stringify({ join_code }) });

export const leaveTeam = (team_id) =>
  jsonFetch(`/${team_id}/leave`, { method: 'DELETE' });

export const removeMember = (team_id, user_id) =>
  jsonFetch(`/${team_id}/members/${user_id}`, { method: 'DELETE' });

export const regenerateJoinCode = (team_id) =>
  jsonFetch(`/${team_id}/regenerate-code`, { method: 'POST' });

// 트리
export const getTeamTree = (team_id) =>
  jsonFetch(`/${team_id}/tree`);

export const addCategory = (team_id, payload) =>
  jsonFetch(`/${team_id}/categories`, { method: 'POST', body: JSON.stringify(payload) });

export const updateCategory = (team_id, category_id, payload) =>
  jsonFetch(`/${team_id}/categories/${category_id}`, { method: 'PUT', body: JSON.stringify(payload) });

export const deleteCategory = (team_id, category_id) =>
  jsonFetch(`/${team_id}/categories/${category_id}`, { method: 'DELETE' });

export const addItem = (team_id, payload) =>
  jsonFetch(`/${team_id}/items`, { method: 'POST', body: JSON.stringify(payload) });

export const updateItem = (team_id, item_id, payload) =>
  jsonFetch(`/${team_id}/items/${item_id}`, { method: 'PUT', body: JSON.stringify(payload) });

export const deleteItem = (team_id, item_id) =>
  jsonFetch(`/${team_id}/items/${item_id}`, { method: 'DELETE' });

// ==================
// 사진 업로드 — estimate-app 백엔드 프록시 → file.skynet.re.kr/hetzner/send
// CORS 우회 + 세션 인증 적용 (브라우저 → 우리 서버 동일 origin)
// ==================
export async function uploadImageToFileServer(file) {
  if (!file) throw new Error('파일이 없습니다.');
  if (!file.type.startsWith('image/')) {
    throw new Error('이미지 파일만 업로드할 수 있습니다.');
  }
  if (file.size > 10 * 1024 * 1024) {
    throw new Error('파일 크기는 10MB 이하여야 합니다.');
  }
  const fd = new FormData();
  fd.append('file', file);
  let res;
  try {
    res = await fetch(`${BASE}/upload-image`, {
      method: 'POST',
      credentials: 'include',
      body: fd,
    });
  } catch (e) {
    throw new Error('서버 연결 실패. 네트워크를 확인하세요.');
  }
  let data = null;
  try { data = await res.json(); } catch { /* empty */ }
  if (!res.ok || !data || !data.success) {
    throw new Error((data && data.error) || `업로드 실패 (HTTP ${res.status})`);
  }
  if (!data.url) throw new Error('업로드 응답에 URL 없음');
  return data.url;
}
